export default "__VITE_ASSET__DLqQQkQZ__"